module.exports = __webpack_public_path__ + "img/pinkDunes.144a96c0.svg";